<template>
  <b-modal
    id="modal-aditivo"
    title="Aditivo"
    no-fade
    size="md"
    no-close-on-esc
    no-close-on-backdrop
  >
    <b-form-row>
      <b-col lg="12">
        <b-form-group
          label="Nº Processo"
          label-size="sm"
          label-for="nr_processo"
        >
          <b-form-input
            size="sm"
            maxlength="50"
            id="nr_processo"
            v-model="aditivo.nr_processo"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-form-group
          label="Valor Estimado R$"
          label-size="sm"
          label-for="vl_estimado"
        >
          <b-form-input
            size="sm"
            maxlength="20"
            id="vl_estimado"
            v-model="aditivo.vl_estimado"
            trim
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: true,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-form-group label="Valor Real R$" label-size="sm" label-for="vl_real">
          <b-form-input
            size="sm"
            maxlength="20"
            id="vl_real"
            v-model="aditivo.vl_real"
            trim
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: true,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-form-group
          label="Prazo em Dias"
          label-size="sm"
          label-for="prazo_dias"
        >
          <b-form-input
            size="sm"
            maxlength="10"
            id="prazo_dias"
            v-model="aditivo.prazo_dias"
            trim
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 0,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: true,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '');
              },
            }"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-form-group label="Tipo" label-size="sm" label-for="ind_tipo">
          <b-form-radio-group
            id="ind_tipo"
            v-model="aditivo.ind_tipo"
            :options="[
              { value: 1, text: 'OFICIAL' },
              { value: 2, text: 'NÃO OFICIAL' },
            ]"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-form-row>
    <template v-slot:modal-footer>
      <b-button size="sm" @click="saveAditivo()" variant="primary">
        <i class="fas fa-check"></i> Gravar
      </b-button>
      <b-button size="sm" @click="() => $bvModal.hide('modal-aditivo')"
        >Cancelar</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";
import { baseApiUrl, showError } from "@/global";
import { bidbus } from "@/main";

export default {
  name: "ModalAditivo",
  props: {
    wbs: { type: Object, required: true },
    aditivo: { type: Object, required: true },
    acao: { type: String, required: true },
  },
  methods: {
    saveAditivo() {
      let _msg = "";

      if ((this.aditivo.nr_processo || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Digite o Nº do Processo!";

      if (_msg !== "") {
        this.$toasted.info(_msg, {
          duration: 4000,
          keepOnHover: true,
          className: "v-toasted-warning",
        });
        return false;
      }

      if (this.acao === "new") {
        this.aditivo.programa_id = this.wbs.programa_id;
        this.aditivo.wbs_id = this.wbs.wbs_id;
        axios
          .post(`${baseApiUrl}/bid/aditivos`, this.aditivo)
          .then(() => {
            // emite o evento local
            this.$emit("updatedAditivo", "");
            // emite o evento para atualizar a aba de medicoes
            bidbus.$emit("refreshMedicoes", "insert modaladitivo");
            this.$bvModal.hide("modal-aditivo");
          })
          .catch(showError);
      } 
      else 
      {
        this.aditivo.programa_id = this.wbs.programa_id;
        this.aditivo.wbs_id = this.wbs.wbs_id;
        axios
          .put(
            `${baseApiUrl}/bid/aditivos/${this.aditivo.aditivo_id}`,
            this.aditivo
          )
          .then(() => {
            this.$emit("updatedAditivo", "");
            bidbus.$emit("refreshMedicoes", "update modaladitivo");
            this.$bvModal.hide("modal-aditivo");
          })
          .catch(showError);
      }
    },
  },
};
</script>

<style></style>
